(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-to')); if (isNaN(to)) return;
    var dec = (String(el.getAttribute('data-to')).split('.')[1] || '').length;
    var suf = el.getAttribute('data-suffix') || '';
    if (reduce) { el.textContent = to.toFixed(dec) + suf; return; }
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = (to * e).toFixed(dec) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function runCalendar(cal) {
    var days = cal.querySelectorAll('.st-cal__d'), n = cal.querySelector('[data-st-cal-n]');
    cal.classList.add('is-run');
    days.forEach(function (d, i) {
      setTimeout(function () { d.classList.add('on'); if (n) n.textContent = i + 1; }, reduce ? 0 : i * 70);
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.st-rv, .st-tl, .st-cal');
    function activate(el) {
      el.classList.add('is-in');
      el.querySelectorAll('[data-to]').forEach(countUp);
      if (el.classList.contains('st-cal')) runCalendar(el);
    }
    if (!('IntersectionObserver' in window)) { items.forEach(activate); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { activate(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initDates(root) {
    root.querySelectorAll('[data-st-date-plus]').forEach(function (el) {
      var d = new Date(); d.setDate(d.getDate() + parseInt(el.getAttribute('data-st-date-plus'), 10));
      el.textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    });
  }

  function initPlans(root) {
    root.querySelectorAll('[data-st-form]').forEach(function (form) {
      var btnPrice = form.querySelector('[data-st-total]');
      function update() { var c = form.querySelector('input[name="id"]:checked'); if (c && btnPrice) btnPrice.textContent = c.getAttribute('data-price'); }
      form.addEventListener('change', update); update();
    });
    var tabs = root.querySelectorAll('[data-st-formula]'), forms = root.querySelectorAll('[data-st-formula-form]');
    if (!tabs.length) return;
    function pick(i) {
      tabs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-st-formula') === String(i)); });
      forms.forEach(function (f) { f.classList.toggle('is-on', f.getAttribute('data-st-formula-form') === String(i)); f.dispatchEvent(new Event('change')); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { pick(t.getAttribute('data-st-formula')); }); });
    pick(0);
  }

  function initCarousel(root) {
    var car = root.querySelector('[data-st-carousel]'); if (!car) return;
    var step = function () { var c = car.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 300; };
    var prev = root.querySelector('[data-st-prev]'), next = root.querySelector('[data-st-next]');
    if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { car.scrollBy({ left: step(), behavior: 'smooth' }); });
  }
  function initGallery(root) {
    var g = root.querySelector('[data-st-gallery]'); if (!g) return;
    var imgs = g.querySelectorAll('.st-pdp__img'), thumbs = g.querySelectorAll('.st-pdp__thumb');
    function show(i) {
      imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-i') === String(i)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-i') === String(i)); });
    }
    var dots = g.querySelectorAll('.st-pdp__dots i');
    var main = g.querySelector('.st-pdp__main'), sx = 0;
    function isScroller() { return main && getComputedStyle(main).overflowX === 'auto'; }
    thumbs.forEach(function (t) { t.addEventListener('click', function () {
      var i = t.getAttribute('data-i');
      if (isScroller()) main.scrollTo({ left: main.clientWidth * parseInt(i, 10), behavior: 'smooth' }); else show(i);
    }); });
    if (main) {
      var tm; main.addEventListener('scroll', function () {
        if (!isScroller()) return; clearTimeout(tm);
        tm = setTimeout(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-i') === String(i)); });
          dots.forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-i') === String(i)); });
        }, 80);
      }, { passive: true });
    }
    if (main && !isScroller()) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) < 40) return;
        var cur = 0; imgs.forEach(function (im, i) { if (im.classList.contains('is-on')) cur = i; });
        show((cur + (dx < 0 ? 1 : imgs.length - 1)) % imgs.length);
      }, { passive: true });
    }
  }

  function initVideos(root) {
    root.querySelectorAll('[data-st-vid]').forEach(function (box) {
      var v = box.querySelector('video'), play = box.querySelector('.st-vid__btn'), mute = box.querySelector('.st-vid__mute');
      if (!v) return;
      play.addEventListener('click', function () {
        document.querySelectorAll('[data-st-vid] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-st-vid]').classList.remove('is-playing'); } });
        v.muted = false; v.play(); box.classList.add('is-playing');
      });
      v.addEventListener('click', function () { v.pause(); box.classList.remove('is-playing'); });
      v.addEventListener('ended', function () { box.classList.remove('is-playing'); });
      mute.addEventListener('click', function () { v.muted = !v.muted; mute.textContent = v.muted ? '🔇' : '🔊'; });
    });
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-st-sticky]'), form = root.querySelector('[data-st-form]'); if (!bar || !form) return;
    var price = bar.querySelector('[data-st-sticky-price]'), go = bar.querySelector('[data-st-sticky-go]');
    function active() { return root.querySelector('[data-st-form].is-on') || form; }
    root.querySelectorAll('[data-st-form]').forEach(function (f) { f.addEventListener('change', function () { if (f !== active()) return; var c = f.querySelector('input[name="id"]:checked'); if (c && price) price.textContent = c.getAttribute('data-price'); }); });
    go.addEventListener('click', function (e) {
      e.preventDefault();
      var f = active(), sb = f.querySelector('[type=submit]');
      if (!sb || sb.disabled) { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (go.disabled) return;
      var old = go.innerHTML; go.disabled = true; go.innerHTML = 'Adding…';
      try { if (f.requestSubmit) f.requestSubmit(sb); else sb.click(); } catch (err) { sb.click(); }
      setTimeout(function () { go.disabled = false; go.innerHTML = old; }, 1600);
    });
    if (!('IntersectionObserver' in window)) return;
    var visible = false, footerIn = false;
    function update() { bar.classList.toggle('is-on', !visible && !footerIn && window.scrollY > 500); }
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; update(); }, { threshold: 0.2 }).observe(form);
    var footer = document.querySelector('footer'); if (footer) new IntersectionObserver(function (en) { footerIn = en[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(footer);
    window.addEventListener('scroll', update, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-st-home]').forEach(function (root) { initDates(root); initReveal(root); initPlans(root); initCarousel(root); initGallery(root); initVideos(root); initSticky(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
